import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { changePassword } from "../../../utils/helpers/password";
import { SEARCH_PROFILE } from "../../../graphql/query/profiles";
import { gql, useLazyQuery } from "@apollo/client";
import { Spin, message } from "antd";

const AccountCard = ({ myBounty }) => {
  const [state, setState] = useState({
    userName: "",
    emailAddress: "",
    password: "",
    confirmPassword: "",
  });
  const [loader, setLoader] = useState(false);
  const { authToken } = useSelector((state) => state.Auth);

  const createPassword = async () => {
    setLoader(true);
    let requestBody = {
      currentPassword: state.password,
      newPassword: state.confirmPassword,
      confirmNewPassword: state.confirmPassword,
    };
    let { status, statusText } = await changePassword(requestBody, authToken);
    // history.push("userdetails");
    setLoader(false);
    if (status === 400 && statusText === "Bad Request") {
      message.error("New passwords do not match");
    } else {
      message.success("password changed");
    }
  };
  const email = localStorage.getItem("email");

  const [getProfileByEmail] = useLazyQuery(gql(SEARCH_PROFILE), {
    onCompleted: ({ searchProfileByEmail }) => {
      setState({ userName: searchProfileByEmail[0]?.userName.toLowerCase() });
    },
    onError: (error) => console.warn(error),
  });

  useEffect(() => {
    getProfileByEmail({
      variables: { email },
    });
  }, []);

  useEffect(() => {
    setState({ emailAddress: email });
  }, []);

  const { userName, emailAddress, password, confirmPassword } = state;
  return (
    <div className="bounty-card-wrappers">
      <Spin spinning={loader}>
        <div className="form-details">
          <div className="input-field">
            <label>User name</label>
            <input
              type="text"
              placeholder="@jinlee"
              name="userName"
              value={userName}
              disabled
              onChange={(event) =>
                setState({ ...state, [event.target.name]: event.target.value })
              }
            />
          </div>
          <div className="input-field">
            <label>Email address</label>
            <input
              type="email"
              placeholder="jin.lee@zombie.app"
              name="emailAddress"
              disabled
              value={emailAddress}
              onChange={(event) =>
                setState({ ...state, [event.target.name]: event.target.value })
              }
            />
          </div>
          <div className="input-field">
            <label>Password</label>
            <input
              type="password"
              placeholder="123456789"
              name="password"
              value={password}
              onChange={(event) =>
                setState({ ...state, [event.target.name]: event.target.value })
              }
            />
          </div>
          <div className="input-field">
            <label>Confirm password</label>
            <input
              type="password"
              placeholder=""
              name="confirmPassword"
              value={confirmPassword}
              onChange={(event) =>
                setState({ ...state, [event.target.name]: event.target.value })
              }
            />
          </div>
          <button
            className="btn-style justify-content-center
              mt-4"
            onClick={createPassword}
          >
            Save changes
          </button>
        </div>
      </Spin>
    </div>
  );
};

export default AccountCard;
